import { render } from "./MutationRequests.vue?vue&type=template&id=2811b336"
import script from "./MutationRequests.vue?vue&type=script&lang=js"
export * from "./MutationRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__